module.exports = __webpack_public_path__ + "img/center1.e8326d64.png";